import { IsOptional } from 'class-validator'
import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IDateRangeFilter } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/inner/IDateRangeFilter'
import { IsRequired } from 'submodules/nerit-framework-utils/validators'

export class DashboardFiltersFormModel extends FormModel {

    @IsRequired()
    samplingCode?: number

    @IsRequired()
    regulationCode?: number

    /** Rótulo da norma selecionada (preenchido pelo select). */
    @IsOptional()
    regulationName?: string

    @IsRequired()
    dateRange?: IDateRangeFilter

    constructor(initialData?: Partial<DashboardFiltersFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
